module.exports = __webpack_public_path__ + "assets/img/22.a79a0d70.png";